export class ApiTokenMock {

  constructor(apiToken: string) {}

  public getUnverifiedUserId() {}

  public getUnverifiedExpirationTimestamp() {
    return Math.floor((new Date()).getTime() / 1000) + 10000
  }

  public getRawToken() {}

  public isVerified() {}

  public getIssuingTestline() {}

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/api-token/api-token.mock.ts